import React, { useState, useEffect } from "react"

import { Card, CardHeader, IconButton, Stack, CardContent } from "@mui/material"
import EditNoteIcon from "@mui/icons-material/EditNote"
import Helpers from "../../../../utils/Helpers"
import api from "../../../../services/AuthApi"
import { FetchErrorHandeling } from "../../../../errorHandeling/FetchErrorHandeling"
import EditLevel from "./EditLevel"
import Alerts from "../../../../errorHandeling/Alerts"

const LevelSetup = () => {
  const [levelData, setLevelData] = useState([])
  const [editingData, setEditingData] = useState()

  const [isDataChanged, setIsDataChanged] = useState(false)

  const [editModalOpen, setEditModalOpen] = useState(false)

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  useEffect(() => {
    api
      .get("/user/levels")
      .then((res) => {
        setLevelData(res.data?.dataList)
        setIsDataChanged(false)

        setErrorMessages([])
        setIserror(false)
      })
      .catch((error) => {
        FetchErrorHandeling(error, setIserror, setErrorMessages, setIserrorShow)
      })
  }, [isDataChanged])

  return (
    <div>
      <div>
        <Alerts
          iserror={iserror}
          errorMessages={errorMessages}
          iserrorShow={iserrorShow}
        />
      </div>
      <Stack
        spacing={{ xs: 1, sm: 2 }}
        direction="row"
        useFlexGap
        sx={{ flexWrap: "wrap" }}
      >
        {levelData?.map((level) => (
          <Card
            sx={{
              maxWidth: 385,
              width: 350,
              height: 200,
              boxShadow: 3,
              borderRadius: "10px",
              position: "relative",
            }}
          >
            <CardHeader
              className="userPermissionCardHeader"
              title={
                <h5>{Helpers.replaceUnderscoresWithSpaces(level.level)}</h5>
              }
              action={
                <div>
                  <IconButton
                    aria-label="settings"
                    onClick={() => {
                      setEditingData(level)
                      setEditModalOpen(true)
                    }}
                  >
                    <EditNoteIcon />
                  </IconButton>
                </div>
              }
            />
            <CardContent
              sx={{
                maxHeight: 200,
                overflowY: "auto",
              }}
            >
              <p>
                <strong>Definition:</strong> {level?.definition}
              </p>
              <p>
                <strong>Description:</strong> {level?.description}
              </p>
            </CardContent>
          </Card>
        ))}
      </Stack>
      <EditLevel
        editingData={editingData}
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        setIsDataChanged={setIsDataChanged}
      />
    </div>
  )
}

export default LevelSetup
